import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { MatTableDataSource, MatDialog, MatSelect } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { ICompany } from "src/app/interfaces/company";
import { ICalendar } from "src/app/interfaces/calendar";
import { ITermInfo } from "src/app/interfaces/term-info";
// import { ICourseType } from "src/app/interfaces/course-type";
import { BIDService } from "src/app/services/common/bid.service";
import { CIDService } from "src/app/services/common/cid.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IGetFullTimeSession } from "src/app/interfaces/get-fullTime-session";
import { ITermInfoByCourseType } from "src/app/interfaces/termInfoByCourseType";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { RoomService } from "./../../../../services/http/business/room/room.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { SettingService } from "src/app/services/http/business/setting/setting.service";
import { AddCourseEntryComponent } from "../add-course-entry/add-course-entry.component";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import { Router } from "@angular/router";
import { AddTeacherEntryComponent } from "../add-teacher-entry/add-teacher-entry.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SoundEnum } from "src/app/enums/sound.enum";
import { RegisterStudentCourseComponent } from "../register-student-course/register-student-course.component";
import { EditCourseEntryComponent } from "../edit-course-entry/edit-course-entry.component";
import { DirectRegisterComponent } from "src/app/pages/registration/direct-register/direct-register.component";
import { ChangeCourseRoomComponent } from "../change-course-room/change-course-room.component";
import { HttpHeaders } from "@angular/common/http";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { SetEduStudentCourseComponent } from "../set-edu-student-course/set-edu-student-course.component";
import { SetFinalDateComponent } from "../set-final-date/set-final-date.component";
import { PrivateCoursePriceComponent } from "../private-course-price/private-course-price.component";
import { SelectTermBatchCourseComponent } from "../select-term-batch-course/select-term-batch-course.component";
import { SendSmsComponent } from "src/app/pages/management/send-sms/send-sms.component";
import { CourseSessionListComponent } from "../course-session-list/course-session-list.component";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-course",
  templateUrl: "./add-course.component.html",
  styleUrls: ["./add-course.component.css"],
  providers: [ErrorsService]
})
export class AddCourseComponent implements OnInit {
  times = [];
  param: any;
  errorList: IError[] = [];
  fullTime: any;
  formDataSchedule: any;
  roomList = [];
  errObject: any;
  isOwner: boolean;
  TermInfoId: number;
  branchList: any;
  yearList: ICalendar;
  errors = new Array();
  companyList: ICompany;
  expand: boolean = true;
  scheduleForm: FormGroup;
  termInfoForm: FormGroup;
  sessionDuration: number;
  timeLineEndPoint: number;
  data: IGetFullTimeSession;
  hideTerms: boolean = true;
  timeLineStartPoint: number;
  addCourseEntryData: any;
  courseTypeList: any;
  hideScheduleTime: boolean = true;
  coursePatternList: any;
  skip: number = 0;

  dataSource = new MatTableDataSource<ITermInfo>();

  displayedColumns: string[] = [
    "function",
    this.translate.get("label.termName"),
    this.translate.get("label.termStartTime"),
    this.translate.get("label.termEndTime")
  ];
  termInfoList: any;
  mainRoomList: any;
  mainFullTime: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private bidService: BIDService,
    private cidService: CIDService,
    private roomService: RoomService,
    private snackbar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private courseService: CourseService,
    private registrationService: RegistrationService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private settingService: SettingService,
    private termInfoService: TermInfoService,
    private calendarService: CalendarService,
    private courseTypeService: CourseTypeService,
    private coursePatternService: CoursePatternService
  ) { }

  ngOnInit() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!this.isOwner) {
        this.hideTerms = true;
        this.hideScheduleTime = true;
        this.loadCoursTypeList();
      }
    });
    this.getCompanyList();
    this.loadYear();
    this.createScheduleForm();
    this.createTermInfoForm();
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.removeBID();
    this.hideTerms = true;
    this.hideScheduleTime = true;
    this.cidService.setCID(e.value);
    this.loadBranchList(e.value);
  }

  setBid(e: MatSelect) {
    let _this = this;
    this.hideTerms = true;
    this.hideScheduleTime = true;
    if (this.isOwner)
      this.bidService.setBID(e.value);

    setTimeout(function () {
      _this.loadCoursTypeList();
    })
  }

  hidePanel() {
    this.hideTerms = true;
    this.hideScheduleTime = true;
  }

  createScheduleForm() {
    this.scheduleForm = this.fb.group({
      sch_CompanyEncryptId: [null, this.isOwner ? Validators.required : null],
      sch_BranchEncryptId: [null, this.isOwner ? Validators.required : null],
      sch_CourseTypeId: [null, Validators.required],
      sch_CoursePatternId: [null, Validators.required],
      sch_Year: [null, Validators.compose([Validators.required])],
      sch_TermInfoId: [null],
      sch_RoomFormat: [true]
    });
  }
  EncryptReplace(en: string) {
    if (en)
      return en.replace(/=/g, '-');
  }

  loadBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  sendSmsGroups() {
    let _this = this;
    let coursePattern = this.coursePatternList.filter(function (e) {
      return e.Id == _this.scheduleForm.value.sch_CoursePatternId
    })[0];
    let termInfo = this.termInfoList.filter(function (e) {
      return e.Id == _this.termInfoForm.value.TermInfoId
    })[0];
    var branch = this.branchList.filter(function (e) {
      return e.BranchEncryptId == _this.scheduleForm.value.sch_BranchEncryptId
    })[0]
    this.dialog
      .open(SendSmsComponent, {
        width: '700px',
        data: {
          CoursePatternName: coursePattern.CourseTypeName + ' - ' + coursePattern.Title,
          TermInfoName: termInfo.ParentTermName + ' - ' + termInfo.Title,
          BranchName: branch.Name,
          BranchEncryptId: this.scheduleForm.value.sch_BranchEncryptId,
          TermInfoId: this.termInfoForm.value.TermInfoId,
          CompanyEncryptId: this.scheduleForm.value.sch_CompanyEncryptId ? this.scheduleForm.value.sch_CompanyEncryptId : this.cidService.getCID(),
          CoursePatternId: this.scheduleForm.value.sch_CoursePatternId
        }
      });
  }


  getColor(course: any) {
    if (course.IsPrivate) {
      return "blue"
    }
    else {
      if (course.CourseStatusId == 10) {
        return "primary"
      }
      if (course.CourseStatusId == 11) {
        return "accent"
      }
      if (course.CourseStatusId == 12) {
        return ""
      }
    }
  }

  loadCoursTypeList() {



    // var headers = new HttpHeaders({
    //   "Content-Type": "application/json"
    // })
    //   .append("Authorization", "Bearer " + localStorage.getItem("token"))
    //   .append(
    //     "HID",
    //     localStorage.getItem("holdingCode")
    //       ? localStorage.getItem("holdingCode")
    //       : ""
    //   )
    //   .append(
    //     "CID",
    //     company
    //   );

    this.courseTypeService.CourseTypeListForAddCourse().subscribe(res => {
      this.courseTypeList = res;
    });
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursePattern(e: MatSelect) {
    this.hideTerms = true;
    this.hideScheduleTime = true;
    this.coursePatternService.getListByCourseTypeId(e.value, 0, 0).subscribe(
      res => {
        this.coursePatternList = res.filter(function (element) {
          return element.IsActive;
        });
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  calculateDuration(e: MatSelect) {
    this.hideTerms = true;
    this.hideScheduleTime = true;
    this.coursePatternService.getById(e.value).subscribe(res => {
      this.sessionDuration = res.SessionDuration;
    });
  }

  showTermInfo(_form) {
    this.formDataSchedule = this.scheduleForm.value;
    this.hideTerms = false;
    this.getTermInfo(this.formDataSchedule, 1, 1000);
  }

  getTermInfo(obj: any, page: number, pageSize: number) {
    this.errors = new Array();
    var data: ITermInfoByCourseType = {
      CourseTypeId: obj.sch_CourseTypeId,
      Year: obj.sch_Year,
      xPage: page,
      xPageSize: pageSize,
      xOrderBy: "",
      xOrderDesc: false
    };
    this.termInfoService.ListByCourseTypeId(data).subscribe(
      res => {
        this.hideTerms = false;
        this.dataSource = res.DataList;
        this.termInfoList = res.DataList;

      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  createTermInfoForm() {
    this.termInfoForm = this.fb.group({
      BranchEncryptId: [this.data ? this.data.BranchEncryptId : null],
      CoursePatternId: [this.data ? this.data.CoursePatternId : null],
      TermInfoId: [null, Validators.compose([Validators.required])]
    });
  }

  getRoomsList() {
    this.roomService.list(0, 0).subscribe(
      res => {
        this.mainRoomList = res.DataList;
        this.roomList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  timeLine() {
    this.times = [];
    this.settingService.getTimeLine().subscribe(
      res => {
        if (res) {
          var _s = new Date("1970-01-01 " + res.CourseTimeStart);
          var _e = new Date("1970-01-01 " + res.CourseTimeEnd);

          while (_s <= _e) {
            this.times.push(('0' + _s.getHours().toString()).slice(-2) + ':' + ('0' + _s.getMinutes()).slice(-2) + ':00')
            _s.setMinutes(_s.getMinutes() + 15);
          }
        }
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  checkFullTime(time: Date, _index, room, session): any {

    let res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test && test.RoomTimeList) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time < element.TimeEnd) {

            if (element.TermInfoId != this.addCourseEntryData.TermInfoId || element.CoursePatternId != this.scheduleForm.value.sch_CoursePatternId) {
              session.isAnother = true;
            }
            else {
              session.isAnother = false;
            }
            res = true;
            session.course = element;
            return;
          }
        });
      }
    }
    if (this.skip > 0) {
    }
    return res;
  }

  checkStartTime(time, _index, room): any {
    let res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test && test.RoomTimeList) {
        test.RoomTimeList.forEach(element => {
          if (time == element.TimeStart) {
            res = true;
            return;
          }
        });
      }
    }
    return res;
  }


  test(time, _index, room): any {
    let res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test && test.RoomTimeList) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time < element.TimeEnd) {
            res = true;
            return;
          }
        });
      }
    }
    return res;
  }

  addCorse(Time: string, roomId: number, room: any) {
    this.addCourseEntryData.RoomId = roomId;
    this.addCourseEntryData.StartTime = Time;
    this.addCourseEntryData.CustomerContractId = room.CustomerContractId;

    this.dialog
      .open(AddCourseEntryComponent, {
        width: "700px",
        data: this.addCourseEntryData
      })
      .afterClosed()
      .subscribe(res => {
        if (res)
          this.submitTermInfo(this.termInfoForm.value)
      });
  }

  CourseBatchInNewTearm() {
    console.log(this.termInfoForm.value)
    this.dialog
      .open(SelectTermBatchCourseComponent, {
        width: "600px",
        data: {
          BranchEncryptId: this.scheduleForm.value.sch_BranchEncryptId,
          TermInfoId: this.termInfoForm.value.TermInfoId,
          CompanyEncryptId: this.scheduleForm.value.sch_CompanyEncryptId ? this.scheduleForm.value.sch_CompanyEncryptId : this.cidService.getCID(),
          CoursePatternId: this.scheduleForm.value.sch_CoursePatternId,
          CourseTypeId: this.scheduleForm.value.sch_CourseTypeId,
        }
      });
  }

  CourseBatchDelete() {
    this.errors = new Array();
    let confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف کلاس های بدون ثبت نام اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        const command = {
          BranchEncryptId: this.scheduleForm.value.sch_BranchEncryptId,
          TermInfoId: this.termInfoForm.value.TermInfoId,
          CoursePatternId: this.scheduleForm.value.sch_CoursePatternId,
        };
        this.courseService.CourseBatchClassDelete(command).subscribe(res => {
          if (res.returnValue)
            this.snackbar.OpenSnackBar(
              "حذف کلاس ها با موفقیت انجام گردید",
              "OK",
              5000,
              SoundEnum.beep
            );
          else
            this.snackbar.OpenSnackBar(
              "خطا  در حذف کلاس ها",
              "OK",
              5000,
              SoundEnum.beep
            );
        }, err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        })
      }
    });




  }

  submitTermInfo(e: any) {
    this.timeLine();
    this.getRoomsList();
    this.calendarService.hasDateList(parseInt(e.TermInfoId)).subscribe();
    this.errors = new Array();
    this.hideScheduleTime = false;
    this.expand = false;

    var model: IGetFullTimeSession = {
      BranchEncryptId: this.scheduleForm.value.sch_BranchEncryptId ? this.scheduleForm.value.sch_BranchEncryptId : this.bidService.getBID(),
      CompanyEncryptId: this.scheduleForm.value.sch_CompanyEncryptId ? this.scheduleForm.value.sch_CompanyEncryptId : this.cidService.getCID(),
      CoursePatternId: this.scheduleForm.value.sch_CoursePatternId,
      RoomFormat: true,
      CourseTypeId: this.scheduleForm.value.sch_CourseTypeId,
      Year: this.scheduleForm.value.sch_Year,
      TermInfoId: parseInt(e.TermInfoId)
    }
    this.addCourseEntryData = model;
    this.courseService.GetFullTimeSession(model).subscribe(
      res => {
        this.fullTime = res;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  sortBy(type: number) {
    switch (type) {
      case 1:
        this.roomList = this.mainRoomList;
        break;
      case 2:
        var sorting = this.fullTime.map(function (item) {
          return item.RoomId
        })
        this.roomList = this.mainRoomList.map(function (item) {
          var n = sorting.indexOf(item.Id);
          if (n == -1)
            return [1000, item]
          else {
            sorting[n] = '';
            return [n, item]
          }
        });
        this.roomList = this.roomList.sort((a, b) => (a[0] > b[0]) ? 1 : -1).map(function (j) { return j[1] })
        break;
      default:
        break;
    }
  }

  addTeacher(id: number) {
    let data = {
      Id: id
    };
    this.courseService.getListIndeterminate(data).subscribe(res => {
      res.Id = id;
      this.dialog
        .open(AddTeacherEntryComponent, {
          data: res,
          width: "700px"
        })
        .afterClosed()
        .subscribe(() => {
          this.submitTermInfo(this.termInfoForm.value);
        });
    });
  }

  setEduOrg(req: any) {
    let data = {
      Id: req.CourseId
    };
    this.registrationService.registerStudentList(data).subscribe(res => {
      this.dialog
        .open(SetEduStudentCourseComponent, {
          data: {
            studentList: res.DataList,
            details: req
          },
          width: "700px"
        })
        .afterClosed()
        .subscribe(() => {
        });
    });
  }

  setFinalDate(req: any) {
    this.dialog
      .open(SetFinalDateComponent, {
        data: req,
        width: "400px"
      })
      .afterClosed()
      .subscribe(() => {
        this.submitTermInfo(this.termInfoForm.value);
      });
  }

  deleteCourse(id: number): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.course")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.courseService.delete({ Id: id }).subscribe(
          () => {
            this.snackbar.OpenSnackBar(
              this.translate.get("success.deleteCourse"),
              "OK",
              5000,
              SoundEnum.beep
            );
            this.submitTermInfo(this.termInfoForm.value);
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  editCourse(id: number) {
    let model = { Id: id };
    this.courseService.getCourseForEdit(model).subscribe(res => {
      console.log(res);
      this.dialog
        .open(EditCourseEntryComponent, {
          width: "700px",
          data: res
        }).afterClosed()
        .subscribe(res => {
          if (res)
            this.submitTermInfo(this.termInfoForm.value)
        });
    })
  }

  courseSessionAllChangeRoom(id: number) {
    let model = { Id: id };
    this.courseService.getCourseForEdit(model).subscribe(res => {
      console.log(res);
      this.dialog
        .open(ChangeCourseRoomComponent, {
          width: "700px",
          data: res
        }).afterClosed()
        .subscribe(res => {
          if (res)
            this.submitTermInfo(this.termInfoForm.value)
        });
    })
  }

  editPrivateClassPrice(id: number) {
    let model = { Id: id };
    this.courseService.getCourseForEdit(model).subscribe(res => {
      this.dialog
        .open(PrivateCoursePriceComponent, {
          width: "700px",
          data: res
        })
    })
  }

  addPrivateClassInvoices(id: number) {
    let model = { Id: id };
    this.courseService.getCourseForEdit(model).subscribe(res => {
      res.ActiveAddInvoice = true;
      this.dialog
        .open(PrivateCoursePriceComponent, {
          width: "700px",
          data: res
        })
    })
  }

  directRegister(course: any) {
    this.dialog.open(DirectRegisterComponent, {
      width: "650px",
      data: course
    }).afterClosed()
      .subscribe(() => {
        this.submitTermInfo(this.termInfoForm.value)
      });
  }

  showStudentList(course: any) {
    this.dialog.open(RegisterStudentCourseComponent, {
      width: "900px",
      data: course
    });
  }

  calcWidth(timeStart, timeEnd) {
    var timeS = Number(timeStart.split(':')[0]) * 60 + Number(timeStart.split(':')[1]);
    var timeE = Number(timeEnd.split(':')[0]) * 60 + Number(timeEnd.split(':')[1]);

    return (timeE - timeS) + 'px';
  }

  courseSessionsCheckout() {
    this.router.navigate(["/management/institute/courseSessionsCheckout"]);
  }
  // directRegister(course: any) {
  //   this.dialog.open(DirectRegisterComponent, {
  //     width: "650px",
  //     data: course
  //   }).afterClosed()
  //     .subscribe(() => {
  //       this.submitTermInfo(this.termInfoForm.value)
  //     });
  // }
  sessions(course: any) {
    this.dialog.open(CourseSessionListComponent, {
      width: "80%",
      maxWidth: "80%",
      data: {
        ...course,
        branchEncryptId: course.BranchEncryptedId, 
        parentTermId: course.ParentTermId
      }
    })
  }
}
